<section class="main">
  <h1>Gates Access</h1>

  <mat-tab-group>
    <mat-tab label="Gate">
      <div class="mt-5 addGate">
        <button class="btn" (click)="addGate()">Add Gate</button>
      </div>
      <section class="sup_main">
        <table class="mt-3 table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th scope="col">Name</th>
              <th scope="col">Type</th>
              <th scope="col">Cctv ip</th>
              <th scope="col">Anpr ip</th>
              <th scope="col">Face recognition ip</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of gates_arr">
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.cctv_ip }}</td>
              <td>{{ item.anpr_ip }}</td>
              <td>{{ item.face_rec_ip }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </mat-tab>

    <mat-tab label="Village">
      <div class="mt-5 addGate">
        <div>
          <mat-form-field>
            <mat-label>Choose Village</mat-label>
            <mat-select (selectionChange)="villageChnage($event)" [(value)]="slectedVillage">
              <mat-option value="all">
                All
              </mat-option>
              <mat-option *ngFor="let item of village_list" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <button class="btn" (click)="add_village_config()">
          Add Village config
        </button>
      </div>

      <section class="mt-3">
        <table class=" table table-striped">
          <thead>
            <tr>
              <th scope="col">Village Name</th>
              <th scope="col">kids access</th>
              <th scope="col">Rented unit</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of villages_arr_table">
              <td>{{ item.name }}</td>
              <td>{{ item.kids_access }}</td>
              <td>{{ item.rented_unit }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </mat-tab>

    <mat-tab label="Users">
      <div class="mt-5 addGate">
        <div>
          <mat-form-field>
            <mat-label>Choose user type</mat-label>
            <mat-select (selectionChange)="changeType($event)" [(value)]="selected_type">
              <mat-option value="all">
                All
              </mat-option>
              <mat-option *ngFor="let item of types_arr" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Choose Village</mat-label>
            <mat-select (selectionChange)="village_user_Chnage($event)" [(value)]="selected_user_village">
              <mat-option value="all">
                All
              </mat-option>
              <mat-option *ngFor="let item of village_list" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <button class="btn" (click)="add_user_config()">
          Add User config
        </button>
      </div>

      <section class="mt-3">
        <table class=" table table-striped">
          <thead>
            <tr>
              <th scope="col">Village Name</th>
              <th scope="col">User Type</th>
              <th scope="col">Anti passback</th>
              <th scope="col">Applying quota</th>
              <th scope="col">Owner existence</th>
              <th scope="col">Vip access</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of users_list_arr">
              <td>{{ item.name }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.anti_passback }}</td>
              <td>{{ item.applying_quota }}</td>
              <td>{{ item.owner_existence }}</td>
              <td>{{ item.vip_access }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </mat-tab>
    <mat-tab label="Qr">
      <div class="mt-5 addGate">
        <div>
          <mat-form-field>
            <mat-label>Choose Qr type</mat-label>
            <mat-select (selectionChange)="changeQrType($event)" [(value)]="selectedQr_type">
              <mat-option *ngFor="let item of types_qr_arr" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Choose Village</mat-label>
            <mat-select (selectionChange)="village_qr_Chnage($event)" [(value)]="selected_qr_village">
              <mat-option *ngFor="let item of village_list" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <button class="btn" (click)="add_qr_config()">
          Add Qr config
        </button>
      </div>

      <section class="mt-3">
        <table class=" table table-striped">
          <thead>
            <tr>
              <th scope="col">Village Name</th>
              <th scope="col">Qr Type</th>
              <th scope="col">One time use</th>
              <th scope="col">Started</th>
              <th scope="col">Ended</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ qrObject.name }}</td>
              <td>{{ qrObject.type }}</td>
              <td>{{ qrObject.one_time_use }}</td>
              <td>{{ qrObject.started }}</td>
              <td>{{ qrObject.ended }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </mat-tab>
  </mat-tab-group>
</section>